export enum PkMatchType {
    NotMatched = 0,
    AutoMatched = 1,
    PrevMatched = 2,
}
